"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _models = require("@seedlang/models");
var _root_store = _interopRequireDefault(require("./root_store"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var CampaignTypeStore = /*#__PURE__*/function (_RootStore) {
  function CampaignTypeStore() {
    var _this;
    (0, _classCallCheck2["default"])(this, CampaignTypeStore);
    _this = _callSuper(this, CampaignTypeStore);
    _this.config = {
      model: _models.CampaignType,
      deserialize: true,
      GET: {
        index: '/campaign_types',
        show: '/campaign_types/:campaignTypeId'
      },
      POST: {
        create: '/campaign_types',
        sendToFilteredUsers: '/campaign_types/:campaignTypeId/send_to_filtered_users'
      },
      PUT: {
        update: '/campaign_types/:campaignTypeId'
      },
      DELETE: {
        destroy: '/campaign_types/:campaignTypeId'
      }
    };
    return _this;
  }
  (0, _inherits2["default"])(CampaignTypeStore, _RootStore);
  return (0, _createClass2["default"])(CampaignTypeStore, [{
    key: "sendToFilteredUsers",
    value: function sendToFilteredUsers(params, callback) {
      this.api(params, callback, 'POST', 'sendToFilteredUsers');
    }
  }]);
}(_root_store["default"]);
var _default = exports["default"] = new CampaignTypeStore();